// extracted by mini-css-extract-plugin
module.exports = {"InputLabel":"Checkbox__InputLabel___3TWA_","GroupCheckbox":"Checkbox__GroupCheckbox___3Cs6e","InputGroup":"Checkbox__InputGroup___CuMn6","Login":"Checkbox__Login___1kZ8O"};